import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React, { useState } from 'react'

import { useUserTableData } from 'src/Libs/service-dashboard/hooks/use-user-table-data'
import { FetchedUserDataConnected } from 'src/Libs/user/models/user.model'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
  tableHeader: {
    whiteSpace: 'pre-line',
  },
  bodyClassName: {
    '&:hover > td': {
      opacity: 1,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.dark,
    },
  },
}))

/**
 * Page to display the list of app users
 */
const UserOverview: React.VFC = () => {
  const { t } = useCustomTranslation()
  const { fetchProps, columns } = useUserTableData()
  const { classes } = useStyles()
  const [filterQuery, setFilterQuery] = useState('')

  return (
    <Box className={classes.container}>
      <ApiView<FetchedUserDataConnected>
        oneFilter={{
          properties: ['user.username', 'location.Email', 'location.Telefon', 'company.Name', 'fullName'],
          label: t('common.search'),
          filterQuery,
          setFilterQuery,
          urlParams: {
            enabled: true,
          },
        }}
        fetchProps={fetchProps}
        tableColumns={columns}
        hasColoredTableColumns
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        headerClassName={classes.tableHeader}
        bodyClassName={classes.bodyClassName}
        listProps={{
          primary: (user: FetchedUserDataConnected) => user.fullName,
          dataQa: (user: FetchedUserDataConnected) => user['user.username'],
          secondary: (user: FetchedUserDataConnected) => user['user.username'],
        }}
      />
    </Box>
  )
}

export default UserOverview
